import { connect } from "react-redux";
import { general } from "../../../../../store/action";
import { Accordion } from "react-bootstrap";

type PACSImagesProps = {
  studyInstanceUID?: string;
};

const PACSImages = ({ studyInstanceUID }: PACSImagesProps) => {
  // studyInstanceUID = "1.3.6.1.4.1.45207.1.1.2.16777343.12955.1778565073.526220";

  // const url = `https://sai-panel.sairantelemetry.ir/ohif/viewer?StudyInstanceUIDs=${studyInstanceUID}`;
  return (
    <>
      <Accordion.Header className="d-flex flex-wrap">
        <div className="flex-fill"></div>
        <span className="font-14 fw-bold me-2 text-black">
          تصاویر پزشکی (PACS)
        </span>
      </Accordion.Header>
      <Accordion.Body className="rounded-bottom bg-primary-10">
        <div className="col-12 row">
          <div className="col-12">
            <div className="card-box p-3">
              {/* <div className="mb-2 fw-bold">فایل صوتی PCG</div> */}

              {studyInstanceUID ? (
                <div>
                  <button
                    onClick={() => window.open(studyInstanceUID, "_blank")}
                    style={{
                      position: "absolute",
                      top: 2,
                      right: 2,
                      zIndex: 2,

                      // glass / crystal style
                      padding: "8px",
                      borderRadius: "12px",
                      border: "1px solid rgba(255, 255, 255, 0.25)",
                      background: "rgba(255, 255, 255, 0.15)",
                      backdropFilter: "blur(10px)",
                      WebkitBackdropFilter: "blur(10px)",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",

                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title="نمایش در صفحه جدید"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M8 3H5a2 2 0 0 0-2 2v3" />
                      <path d="M16 3h3a2 2 0 0 1 2 2v3" />
                      <path d="M21 16v3a2 2 0 0 1-2 2h-3" />
                      <path d="M3 16v3a2 2 0 0 0 2 2h3" />
                      <path d="M9 9h6v6H9z" />
                    </svg>
                  </button>
                  <iframe
                    src={studyInstanceUID}
                    style={{
                      width: "100%",
                      height: "100vh",
                      border: "none",
                    }}
                    allow="fullscreen"
                  />
                </div>
              ) : (
                <div className="alert alert-info text-center mb-0">
                  هیچ تصویر پزشکی برای این بیمار ثبت نشده است.
                </div>
              )}
            </div>
          </div>
        </div>
      </Accordion.Body>
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  handleShowModal: (data: any, body: any) =>
    dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PACSImages);
